import React from 'react';
import { FaIcon } from '@shipstation/svgs';
import classnames from 'classnames';

import { InlineMessageTypePropType } from './prop-types';
import style from './style.less';
import { INLINE_MESSAGE_TYPES } from './types';
import Tooltip from '../tooltip';

/**
 * @typedef {import('./inline-message-types.d.ts').InlineMessageComponent} InlineMessageComponent
 */

/**
 * @typedef {import('./inline-message-types.d.ts').WithTooltipComponent} WithTooltipComponent
 */

const Icon = {
  [INLINE_MESSAGE_TYPES.error]: <FaIcon className={style.icon} name='exclamation-circle' />,
  [INLINE_MESSAGE_TYPES.warning]: <FaIcon className={style.icon} name='exclamation-triangle' />,
  [INLINE_MESSAGE_TYPES.info]: <FaIcon className={style.icon} name='info-circle' />,
};

/**
 * WithTooltip component
 * @type {WithTooltipComponent}
 */
const WithTooltip = ({ tooltipContent, children }) => (tooltipContent ? <Tooltip text={tooltipContent}>{children}</Tooltip> : children);

/**
 * InlineMessage component
 * @type {InlineMessageComponent}
 */
const InlineMessage = ({ children, className = '', type = '', tooltipContent }) => (
  <WithTooltip tooltipContent={tooltipContent}>
    <div className={classnames(style['helper-text'], style[type], className)}>
      {INLINE_MESSAGE_TYPES[type] ? Icon[type] : null}
      <div className={style.text}>{children}</div>
    </div>
  </WithTooltip>
);

export { InlineMessageTypePropType, INLINE_MESSAGE_TYPES };

export default InlineMessage;
